import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/sections/Hero";
import { MusicGrid } from "@/components/sections/MusicGrid";
import { Upcoming } from "@/components/sections/Upcoming";
import { Watch } from "@/components/sections/Watch";
import { ListenEverywhere } from "@/components/sections/ListenEverywhere";
import { Manifesto } from "@/components/sections/Manifesto";
import { MerchTeaser } from "@/components/sections/MerchTeaser";
import { StayConnected } from "@/components/sections/StayConnected";
import { Marquee } from "@/components/site/Marquee";
import { useSite } from "@/context/SiteContext";
import { scrollToId } from "@/components/site/SmoothScroll";

const MARQUEE = ["Love", "Faith", "Purpose", "Melody", "Emotion", "Vibes"];

export default function Landing() {
  const site = useSite();
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target && !site.loading) {
      const t = setTimeout(() => scrollToId(target), 400);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [location.state, site.loading]);

  return (
    <main data-testid="landing-page">
      <Hero pages={site.pages} featured={site.featured} />
      <Marquee words={MARQUEE} />
      <MusicGrid music={site.music} />
      <Upcoming upcoming={site.upcoming} />
      <Watch videos={site.videos} />
      <ListenEverywhere links={site.links} featured={site.featured} />
      <Manifesto />
      <MerchTeaser merch={site.merch} />
      <StayConnected />
    </main>
  );
}
